import styled from "styled-components";

export const StyledPotholeFilterStatus = styled.div`
  width: 100%;
  min-width: 1500px;
  display: flex;
  flex-flow: column nowrap;
  position: relative;
`;
